export default __webpack_public_path__ + "static/media/YT2.8694eb6e.png";